export default function Services() {
  const services = [
    {
      icon: 'ri-ship-line',
      title: 'Importación Directa',
      description: 'Conexión directa con fabricantes chinos de primera línea. Eliminamos intermediarios para ofrecerte los mejores precios del mercado sin comprometer la calidad premium que tus proyectos merecen.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Control de Calidad',
      description: 'Inspección rigurosa en origen con certificados internacionales. Nuestro equipo en China verifica cada lote antes del envío, garantizando que solo recibas materiales que cumplan los más altos estándares europeos.'
    },
    {
      icon: 'ri-truck-line',
      title: 'Logística Integral',
      description: 'Gestión completa desde fábrica hasta tu obra. Nos encargamos de toda la documentación aduanera, transporte marítimo y terrestre, y entrega puntual en tu ubicación en España.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: 'Asesoramiento Técnico',
      description: 'Equipo especializado en materiales de construcción y decoración. Te ayudamos a seleccionar los productos ideales para cada proyecto, con especificaciones técnicas detalladas y muestras físicas disponibles.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Documentación Completa',
      description: 'Certificados CE, fichas técnicas y garantías oficiales. Proporcionamos toda la documentación necesaria para cumplir con la normativa española y europea en tus proyectos profesionales.'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Precios Competitivos',
      description: 'Tarifas especiales para profesionales y volumen. Ofrecemos condiciones comerciales ventajosas con descuentos por cantidad, financiación flexible y plazos de pago adaptados a tu negocio.'
    }
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-900 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Nuestros Servicios
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-6">
            Soluciones Integrales para Profesionales
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ofrecemos un servicio completo de importación diseñado específicamente para arquitectos, interioristas, tiendas especializadas y grandes constructoras que buscan excelencia y eficiencia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-white rounded-xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-blue-200 group"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-blue-900 to-blue-700 rounded-lg mb-6 group-hover:scale-110 transition-transform">
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-blue-900 mb-4">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
